import { styled, TableRow } from "@mui/material";
import React from "react";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#0000001c!important",
  },
}));
export default function MDTableRow({ children, ...rest }: any) {
  return <StyledTableRow {...rest}>{children}</StyledTableRow>;
}
